/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PraticaConflittoDTO { 
    id_pratica?: string;
    codice_pratica?: string;
    stato?: PraticaConflittoDTOStatoEnum;
    timestamp_richiesta?: string;
    motivi?: Array<PraticaConflittoDTOMotiviEnum>;
}
export enum PraticaConflittoDTOStatoEnum {
    IN_ATTESA_OTP = 'IN_ATTESA_OTP',
    RICHIESTA_SOTTOMESSA = 'RICHIESTA_SOTTOMESSA',
    RICHIESTA_IN_LAVORAZIONE = 'RICHIESTA_IN_LAVORAZIONE',
    RICHIESTA_ACCETTATA = 'RICHIESTA_ACCETTATA',
    RICHIESTA_RIFIUTATA = 'RICHIESTA_RIFIUTATA',
    VOUCHER_ASSEGNATI = 'VOUCHER_ASSEGNATI',
    VOUCHER_CONSEGNATI = 'VOUCHER_CONSEGNATI'
};
export enum PraticaConflittoDTOMotiviEnum {
    CF = 'CF',
    ANPR = 'ANPR'
};



